<template>
  <timeline-item :type="status" :date="object.date_status">
    <template v-slot:body>
      <span v-if="object.credits > 0" class="m-badge m-badge--wide flex-shrink-0 m-badge--danger mb-2 mr-2">
        -&nbsp;{{ object.credits }}&nbsp;{{pointsSymbol}}
      </span>
      <span v-if="object.type === '1'" class="m-badge m-badge--wide flex-shrink-0 mb-2" v-b-tooltip.hover.html
            :title="`${details.name} ${details.surname} <br> ${details.address} <br> ${details.postcode} ${details.city}`">
        Wysyłka na adres
      </span>
      <span v-if="object.type === '3'" class="m-badge m-badge--wide flex-shrink-0 mb-2">
        Odbiór w {{ object.shop_name }}
      </span>
      <div>
        <span class="m-timeline-1__item-title">{{ object.reward_name }}</span> ({{ object.quantity }} szt.)
        <span v-if="object.quantity > 2"></span>
      </div>
    </template>
    <template v-slot:actions>
      <button v-if="isDigital && hasDigitalReward" class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls"
              @click="setDigitalOrderModalId(object.id)">
        Zobacz
      </button>
    </template>
  </timeline-item>
</template>

<script>
import TimelineItem from '@/components/timeline/TimelineItem';
import {mapActions, mapState} from "vuex";

export default {
  name: "ReceivedRewardsTimelineItem",
  components: {TimelineItem},
  props: ['object'],
  methods: {
    ...mapActions([
      'setDigitalOrderModalId'
    ]),
  },
  computed: {
    ...mapState({
      pointsConfig: state => state.settings.points,
      pointsSymbol() {
        return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
      },
    }),
    status() {
      switch (parseInt(this.object.status)) {
        case 0:
          return 'Oczekujące';
        case 1:
          return 'Wysłane';
        case 2:
          return 'Wydane';
        case 3:
          return 'Anulowane';
      }
    },
    isDigital() {
      return this.object.type === '2';
    },
    hasDigitalReward() {
      return JSON.parse(this.object.details).digitalReward.length
    },
    details() {
      return JSON.parse(this.object.details);
    }
  }
}
</script>

<style scoped>

</style>
